var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',{staticClass:"splash-screen-wrapper d-flex flex-column",attrs:{"fill-height":"","align-center":"","justify-center":""}},[_c('div',{staticClass:"neutral6--text"},[_vm._v("powerd by")]),_c('div',{staticClass:"text-h4 font-weight-black russo-one"},[_vm._v("Gainmes")])])
}
var staticRenderFns = []

export { render, staticRenderFns }